const { defineStore } = require("pinia");

export const useToastsStore = defineStore("toasts", {
    state: () => ({
        toasts: [],
        _nextToastId: 1
    }),
  
    actions: {
        add(newToastData) {
            if (typeof newToastData === "string") {
                this.toasts.push({
                    id: this._nextToastId++,
                    title: newToastData
                });
            } else {
                this.toasts.push({
                    id: this._nextToastId++,
                    ...newToastData
                });
            }
        },

        success(newToastData) {
            if (typeof newToastData === "string") {
                this.add({ type: "success", title: newToastData });
            } else {
                this.add({ type: "success", ...newToastData });
            }
        },
        
        warning(newToastData) {
            if (typeof newToastData === "string") {
                this.add({ type: "warning", title: newToastData });
            } else {
                this.add({ type: "warning", ...newToastData });
            }
        },

        danger(newToastData) {
            if (typeof newToastData === "string") {
                this.add({ type: "danger", title: newToastData });
            } else {
                this.add({ type: "danger", ...newToastData });
            }
        },
        
        remove(toastId) {
            const toastIdx = this.toasts.findIndex(toast => toast.id === toastId); 

            if (toastIdx !== -1) {
                this.toasts.splice(toastIdx, 1);
            }
        },
    }
})